import store from '../store'

export function showBilagEmailPdfModal (paymentMethod, bilag) {
  if (paymentMethod === 'none') {
    openModal('bilag-email-pdf-modal',
      { query: bilag, internalWindow: true },
      'split'
    )
  }
}

function openModal (modalName, modalProps, modalType, modalOnCloseEvent) {
  store.dispatch('OPEN_MODAL', {
    modalName: modalName,
    modalProps: modalProps || null,
    modalType: modalType || null,
    modalOnCloseEvent: modalOnCloseEvent || null
  })

  window.jQuery('body').addClass('scroll-lock')
}



// WEBPACK FOOTER //
// ./src/helpers/ModalHelpers.js